// API Configuration
export const API_CONFIG = {
  API_KEY: process.env.REACT_APP_SAMSARA_API_KEY || 'placeholder_api_key',
  API_GATEWAY_ID: process.env.REACT_APP_SAMSARA_API_GATEWAY_ID || 'placeholder_gateway_id',
  API_REGION: process.env.REACT_APP_SAMSARA_API_REGION || 'us-east-1',
  API_ENVIRONMENT: process.env.REACT_APP_SAMSARA_API_ENVIRONMENT || '/dev'
}

// Check if we have real API credentials
export const hasRealAPICredentials = () => {
  // Check if we actually have real environment variables set
  return !!(process.env.REACT_APP_SAMSARA_API_KEY && 
           process.env.REACT_APP_SAMSARA_API_GATEWAY_ID &&
           process.env.REACT_APP_SAMSARA_API_KEY !== 'placeholder_api_key' && 
           process.env.REACT_APP_SAMSARA_API_GATEWAY_ID !== 'placeholder_gateway_id')
}

// Base URL for API calls
export const getAPIBaseURL = () => 
  `https://${API_CONFIG.API_GATEWAY_ID}.execute-api.${API_CONFIG.API_REGION}.amazonaws.com${API_CONFIG.API_ENVIRONMENT}`
